export const NameValidation=[
   
    { required: true, message:'Name is required' }, 
    {pattern:/^[a-zA-Z ]/, message:'Name must have only letters'},
    {max:50, message:'Name must have maximum of 30 letters'},
    {min:2, message:'Name must have minimum of 2 letters'},
   
];